import { useState } from "react";
import {
  auth,
  facebookProvider,
  googleProvider,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "../../firebaseSetup";
import { IconContext } from "react-icons";
import { IoMdCloseCircle } from "react-icons/io";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { StyledFieldset } from "../../pages/Contact";
import { setTimeActive, login } from "../../services/userSlice";
import { StyledLink } from "../../utils/button";
import { Backdrop, CircularProgress } from "@mui/material";

interface Props {
  loginStyle: React.CSSProperties;
  handleClick: () => void;
  switchSignup: () => void;
}

const LoginCart = ({ loginStyle, handleClick, switchSignup }: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [formData, setformData] = useState({
    email: "",
    password: "",
  });
  const [buttonState, setButtonState] = useState({
    google: false,
    facebook: false,
    submit: false,
    backDrop: false,
  });
  const handleBackdropClose = () => {
    setButtonState((prevButtonState) => {
      return {
        ...prevButtonState,
        backDrop: false,
      };
    });
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setformData((prevFormData) => {
      return {
        ...prevFormData,
        [name]: value,
      };
    });
  };

  const handleLogin = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setButtonState((prevButtonState) => {
      return {
        ...prevButtonState,
        submit: true,
      };
    });
    setButtonState((prevButtonState) => {
      return {
        ...prevButtonState,
        backDrop: true,
      };
    });
    setTimeout(() => {
      signInWithEmailAndPassword(auth, formData.email, formData.password)
        .then(() => {
          if (!auth.currentUser!.emailVerified) {
            sendEmailVerification(auth?.currentUser!)
              .then(() => {
                dispatch(setTimeActive(true));
                navigate("/verify-email");
              })
              .catch((err) => alert(err.message));
          } else {
            navigate("/checkout");
          }
        })
        .catch((err) => setError(err.message));

      setformData((prevFormData) => {
        return {
          ...prevFormData,
          email: "",
          fullName: "",
          password: "",
        };
      });
    }, 800);
  };

  const signInWithGoogle = () => {
    setButtonState((prevButtonState) => {
      return {
        ...prevButtonState,
        google: true,
      };
    });
    setButtonState((prevButtonState) => {
      return {
        ...prevButtonState,
        backDrop: true,
      };
    });

    setTimeout(() => {
      signInWithPopup(auth, googleProvider).then(() => {
        if (!auth.currentUser?.emailVerified) {
          sendEmailVerification(auth?.currentUser!)
            .then(() => {
              dispatch(setTimeActive(true));
              navigate("/verify-email");
            })
            .catch((err) => alert(err.message));
        } else {
          navigate("/checkout");
        }
      });
    }, 1200);
  };

  const signInWithFacebook = () => {
    setButtonState((prevButtonState) => {
      return {
        ...prevButtonState,
        facebook: true,
      };
    });
    setButtonState((prevButtonState) => {
      return {
        ...prevButtonState,
        backDrop: true,
      };
    });

    setTimeout(() => {
      signInWithPopup(auth, facebookProvider).then((result) => {
        // The signed-in user info.
        const user = result.user;
        dispatch(
          login({
            ...user,
          }),
        );
        if (!user?.emailVerified) {
          sendEmailVerification(user!)
            .then(() => {
              dispatch(setTimeActive(true));
              navigate("/verify-email");
            })
            .catch((err) => alert(err.message));
        } else {
          navigate("/checkout");
        }

        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        // const credential = FacebookAuthProvider.credentialFromResult(result);
        // const accessToken = credential?.accessToken!;

        // ...
      });
      // .catch((error) => {
      //   // Handle Errors here.
      //   const errorCode = error.code;
      //   const errorMessage = error.message;
      //   // The email of the user's account used.
      //   const email = error.customData.email;
      //   // The AuthCredential type that was used.
      //   const credential = FacebookAuthProvider.credentialFromError(error);

      //   // ...
      // });
    }, 1200);
  };

  return (
    <div
      className="cart-login"
      style={loginStyle}
    >
      <div className="login-content">
        <div className="cart-auth-modal-icon">
          <IconContext.Provider value={{ className: "modal-check-close" }}>
            <IoMdCloseCircle onClick={handleClick} />
          </IconContext.Provider>
        </div>

        <h2>Login</h2>
        <div className="auth-choice">
          <a onClick={signInWithGoogle}>Continue with google</a>
          <a onClick={signInWithFacebook}>Continue with facebook</a>
        </div>

        <p>or signin with</p>

        <form
          className="login-form"
          name="login-form"
          onSubmit={handleLogin}
          autoComplete="off"
        >
          <StyledFieldset>
            <input
              type="email"
              placeholder="Your email"
              required
              name="email"
              value={formData.email}
              autoComplete="new-email"
              onChange={handleChange}
            />
            <input
              type="password"
              placeholder="Password"
              required
              name="password"
              value={formData.password}
              onChange={handleChange}
              autoComplete="new-password"
            />
            <p>Forgot Password?</p>
          </StyledFieldset>
          <StyledLink
            className="signup-button"
            as="button"
            type="submit"
            style={{ opacity: buttonState.submit ? 0.6 : 1 }}
          >
            Signup{" "}
            {buttonState.submit && (
              <CircularProgress
                sx={{
                  color: "white",
                }}
              />
            )}
          </StyledLink>
        </form>
        <p>
          Don't have an account?
          <span
            onClick={switchSignup}
            style={{ cursor: "pointer" }}
          >
            Signup
          </span>
        </p>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={buttonState.backDrop}
        onClick={handleBackdropClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default LoginCart;
